
export default {
    name: 'atcd-historique-allergologie-personnel',
    components: {},
    props: ["consultation", "activeRole", "is_printable"],
    data() {
        return {
            is_loading: true,
            is_physio: true,
            histo_is_empty: false,
        }
    },
    computed: {
        antecedent_allergo_personnel_historique() {
            return this.$store.getters["antecedent_allergo_personnel_historique"];
        },
    },
    mounted() {
        this.listeChampATCDAllergoPersonnel()
    },
    methods: {
        async listeChampATCDAllergoPersonnel() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_personnel',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.antecedent_allergo_personnel_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },

        toggleSection() {
            this.is_physio = (this.is_physio)?false:true
        },
    }
}


